/**
 * SmileFresh — store Google Ads gclid/gbraid/wbraid and append to Timely book links.
 * Drop into Shopify theme / GTM Custom HTML on all pages (run once per page load).
 * Does not invent IDs — only keeps what Google auto-tagging already put on the URL.
 */
(function () {
  var KEYS = ['gclid', 'gbraid', 'wbraid'];
  var STORE = 'sf_gads_click_ids';
  var DAYS = 90;

  function readStore() {
    try { return JSON.parse(localStorage.getItem(STORE) || '{}') || {}; }
    catch (e) { return {}; }
  }
  function writeStore(obj) {
    try { localStorage.setItem(STORE, JSON.stringify(obj)); } catch (e) {}
  }
  function fromQuery() {
    var q = new URLSearchParams(location.search);
    var out = {};
    KEYS.forEach(function (k) {
      var v = q.get(k);
      if (v) out[k] = v;
    });
    return out;
  }
  function merge() {
    var cur = readStore();
    var fresh = fromQuery();
    var changed = false;
    KEYS.forEach(function (k) {
      if (fresh[k] && fresh[k] !== cur[k]) { cur[k] = fresh[k]; changed = true; }
    });
    if (changed || !cur.saved_at) {
      cur.saved_at = Date.now();
      writeStore(cur);
    }
    // expire
    if (cur.saved_at && Date.now() - cur.saved_at > DAYS * 864e5) {
      writeStore({});
      return {};
    }
    return cur;
  }
  function appendParams(href, ids) {
    try {
      var u = new URL(href, location.origin);
      if (u.hostname.indexOf('gettimely.com') === -1 && u.hostname.indexOf('timely') === -1) return href;
      KEYS.forEach(function (k) {
        if (ids[k] && !u.searchParams.get(k)) u.searchParams.set(k, ids[k]);
      });
      return u.toString();
    } catch (e) { return href; }
  }
  var ids = merge();
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
    if (!a) return;
    var next = appendParams(a.href, ids);
    if (next !== a.href) a.href = next;
  }, true);

  function rewriteAll(ids) {
    var nodes = document.querySelectorAll('a[href*="gettimely.com"], a[href*="timely"]');
    for (var i = 0; i < nodes.length; i++) {
      var next = appendParams(nodes[i].href, ids);
      if (next !== nodes[i].href) nodes[i].href = next;
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { rewriteAll(ids); });
  } else {
    rewriteAll(ids);
  }

})();
